import React, { useEffect, useState } from "react";
// import PageLayout from './layouts/PageLayout';
import PageLayout from "./layouts/PageLayout";
import SearchWrapper from "./layouts/SearchWrapper";
import Header from "./layouts/Header";
import BannerOne from "./layouts/BannerOne";
import Features from "./layouts/Features";
import TrustBadges from "./layouts/TrustBadges";
import ServicesShowcase from "./layouts/ServicesShowcase";
import AboutArea from "./layouts/AboutArea";
import HowCanHelpTwo from "./layouts/HowCanHelpTwo";
import ServiceArea from "./layouts/ServiceArea";
import WhyChooseUs from "./layouts/WhyChooseUs";
import RecentProducts from "./layouts/RecentProducts";
import Cta from "./layouts/Cta";
import Testimonials from "./layouts/Testimonials";
import BlogArea from "./layouts/BlogArea";
import Footer from "./layouts/Footer";
import VipPromoBand from "./layouts/VipPromoBand";
// eslint-disable-next-line no-unused-vars
import HiringPrompt from "./HiringPrompt/HiringPrompt"; // Saved for future use
// eslint-disable-next-line no-unused-vars
import PremiumModal from "./PremiumModal/PremiumModal"; // Saved for future use
// eslint-disable-next-line no-unused-vars
import NewsletterModal from "./NewsletterModal/NewsletterModal"; // Saved for future use

const HomeOne = () => {
  // eslint-disable-next-line no-unused-vars
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPrompt(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <PageLayout
      title="Cell Station – Home | Expert Cellphone Repair"
      description="Trusted cellphone repair in Willow Grove, PA. Same-day service for iPhone, Samsung, tablets & more."
      url="https://www.icellstation.com/"
    >
      <SearchWrapper />
      <Header />
      <BannerOne />
      <TrustBadges />
      <ServicesShowcase />
      {/* {showPrompt && <PremiumModal onClose={() => setShowPrompt(false)} />} */}
      {/* {showPrompt && <NewsletterModal onClose={() => setShowPrompt(false)} />} */}
      <Features />
      <AboutArea design="home_1" />
      <HowCanHelpTwo />
      <ServiceArea background={true} />
      <WhyChooseUs />
      <VipPromoBand />
      <RecentProducts />
      <Cta />
      <Testimonials />
      <BlogArea />
      {/* Map Section with Store Photo */}
      <div style={{ position: 'relative', width: '100%' }}>
        <iframe
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1112.526522562257!2d-75.12602792321633!3d40.13197566201095!2m3!1f0!2f39.121133786135466!3f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0x89c6b1fc42ab6fef%3A0x7c78b804e3a9c5ec!2sCell%20Station!5e1!3m2!1sen!2sus!4v1730661192650!5m2!1sen!2sus"
          width="100%"
          height="500"
          title="Cell Station Location"
          style={{ border: 0 }}
          allowFullScreen
        />
        {/* Store Photo Overlay */}
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '20px',
            width: '280px',
            background: '#ffffff',
            borderRadius: '16px',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.25)',
            overflow: 'hidden',
            border: '3px solid #ffffff',
            zIndex: 10,
          }}
        >
          <img
            src={process.env.PUBLIC_URL + '/assets/images/store-front.jpg'}
            alt="Cell Station Store Front"
            style={{
              width: '100%',
              height: '160px',
              objectFit: 'cover',
              display: 'block',
            }}
          />
          <div
            style={{
              padding: '12px 16px',
              background: 'linear-gradient(135deg, #18305d 0%, #0f1d3a 100%)',
            }}
          >
            <h4
              style={{
                color: '#ffffff',
                fontSize: '15px',
                fontWeight: '700',
                margin: '0 0 4px 0',
              }}
            >
              <i className="fas fa-store" style={{ color: '#ffaa19', marginRight: '8px' }}></i>
              Cell Station
            </h4>
            <p
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '12px',
                margin: 0,
              }}
            >
              <i className="fas fa-map-marker-alt" style={{ color: '#ffaa19', marginRight: '6px' }}></i>
              Willow Grove, PA
            </p>
          </div>
        </div>

        {/* Responsive styles for store photo */}
        <style>{`
          @media (max-width: 576px) {
            div[style*="position: absolute"][style*="bottom: 20px"] {
              width: 200px !important;
              bottom: 10px !important;
              left: 10px !important;
            }
            div[style*="position: absolute"][style*="bottom: 20px"] img {
              height: 110px !important;
            }
          }
        `}</style>
      </div>
      <Footer />
    </PageLayout>
  );
};

export default HomeOne;
